<template>
  <el-dialog
    :visible="visible"
    title="Подтверждение"
    width="40%"
    custom-class="print-ext"
    append-to-body
    @close="onClose"
  >
    <el-form
      ref="printExtension"
      :model="formData"
      :rules="rules"
      label-position="top"
    >
      <el-form-item prop="dogovor_number" label="Номер договора:">
        <el-input v-model="formData.dogovor_number" />
      </el-form-item>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item prop="dogovor_date" label="Дата договора:">
            <el-date-picker
              v-model="formData.dogovor_date"
              type="date"
              placeholder="Выберите дату"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="agreement_date" label="Дата создания соглашения:">
            <el-date-picker
              v-model="formData.agreement_date"
              type="date"
              placeholder="Выберите дату"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="ta-r btn-block">
        <el-button type="primary" @click="onPrint"> Распечатать </el-button>
      </el-row>
    </el-form>
  </el-dialog>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { pickerOpt } from '@/datas/consts'

const Doc = RepositoryFactory.get('document')

export default {
  name: 'PrintExtensionModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      default: 0,
    },
    inn: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      pickerOptions: pickerOpt,
      formData: {
        dogovor_number: '',
        dogovor_date: '',
        agreement_date: '',
      },
      rules: {
        dogovor_number: {
          required: true,
          message: 'Укажите номер договора',
          trigger: 'blur',
        },
        dogovor_date: {
          required: true,
          message: 'Укажите дату договора',
          trigger: 'blur',
        },
        agreement_date: {
          required: true,
          message: 'Выберите дату создания соглашения',
          trigger: 'blur',
        },
      },
    }
  },
  methods: {
    onPrint() {
      this.$refs['printExtension'].validate(valid => {
        if (valid) {
          const data = {
            ...this.formData,
            contragent_id: this.id,
            performer_inn: this.inn,
          }
          const path = Doc.getReportLink(
            'word-builder/template/dogovor_extension',
            data,
          )

          this.downloadRegistry({ path })
          this.onClose()
        }
      })
    },
    onClose() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="sass">
.print-ext
  .btn-block
    margin-top: 20px
  .el-date-editor
    width: 100%
</style>
